//Enegeticinspektionsstatus auf Auftragsebene
export enum EnergeticInspectionStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  WaitingForData = 'WAITING_FOR_DATA',
  InReview = 'IN_REVIEW',
  Completed = 'COMPLETED',
}

export const EnergeticInspectionStatusLabels: {
  [key in EnergeticInspectionStatus]: string;
} = {
  [EnergeticInspectionStatus.Pending]: 'Ausstehend',
  [EnergeticInspectionStatus.InProgress]: 'In Durchführung',
  [EnergeticInspectionStatus.WaitingForData]: 'Warten auf Daten',
  [EnergeticInspectionStatus.InReview]: 'Berichtsprüfung',
  [EnergeticInspectionStatus.Completed]: 'Abgeschlossen',
};
